<div class="card">
  <div class="service">
    <div class="service__left service__left--no-padding">
      <svg-icon src="assets/images/icons/status-{{ healthState() | status_to_icon }}.svg"></svg-icon>
      <div class="service__header-caption">
        <div class="service__title-wrapper service__title-wrapper--space-between">
          <h3 class="service__title">{{ customerDescription() }}</h3>
        </div>
      </div>
    </div>

    <div class="service__flex-table">
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.PortSpeed" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ portSpeed() | service_speed }}</div>
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.PatchPosition" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ patchPosition() }}</div>
        </div>
      </div>
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.InterfaceType" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ interfaceType() }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
